<template>

  <v-dialog
    v-model="show"
    persistent
    width="720"
    >
    <div style="background-color: #fff;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{state=='new'?'New':'Modify'}} Vendor</span>
            <v-spacer/>
            <v-btn fab x-small elevation="1" color="warning"  @click="emitToParent('close')"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
    <v-row no-gutters>
      <v-col cols="12">
           <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <v-card class="ma-1">
                <v-card-text>
                  
                        <table class="va-table va-align-top">
                          
                          <tr>
                            <td class="pa-2"> 
                            <span  class="text-secondary px-3 lightgray">Company</span>  
                              <v-divider class="mb-4" color=""/>
                              <v-row no-gutters>
                                <v-col cols="12">
                                  <v-text-field
                                  dense
                                  v-model="vendor.name"
                                  :rules="FieldRules('Please enter a company name')"
                                  label="Company Name"
                                />
                                </v-col>
                                <v-col cols="6">
                                      <v-text-field
                                      v-model="contact.telephone"
                                      dense
                                    label="Telephone No."
                                    />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                  v-model="contact.mobile"
                                  dense
                                  label="Mobile No."
                                />
                                </v-col>
                              </v-row> 
                            
                                <v-text-field
                                  v-model="contact.email"
                                  dense
                                  label="Email Address"
                                />

                            
                              
                          </td>
                            <td width="50%" class="pa-2">
                              <span  class="text-secondary px-3 lightgray">Contact Person</span>  
                              <v-divider class="mb-4" color=""/>
                              
                              <v-row no-gutters>
                                <v-col cols="4">
                                  <v-combobox
                                  v-model="contact_person.title"
                                  dense
                                  label="Title"
                                  :items="['Mr.', 'Mrs.', 'Ms.']"
                                />
                                </v-col>
                                <v-col cols="8">
                                  <v-text-field
                                  v-model="contact_person.firstname"
                                  dense
                                  label="First Name"
                                />
                                </v-col>
                                <v-col cols="9">
                                      <v-text-field
                                      v-model="contact_person.lastname"
                                      dense
                                      label="Last Name"
                                    />
                                </v-col>
                                <v-col cols="3">
                                  <v-text-field
                                  v-model="contact_person.middle"
                                  dense
                                  label="M.I"
                                />
                                </v-col>
                              </v-row> 
                          </td>
                          
                        
                          </tr>

                          <tr>
                            <td  class="pa-2" colspan="2">
                              <span class="text-secondary px-3 lightgray"> Address</span>   
                              <v-divider class="mb-4"/>
                              
                            
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-textarea
                                      rows="2"
                                      v-model="address.line_address"
                                        dense
                                        label="Company Address"
                                      />
                                  </v-col> 
                                 
                                </v-row>
                              
                            </td>
                          
                          </tr>  
                        </table>
                </v-card-text> 

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn tile text small ripple  @click="emitToParent('close')">
                      <v-icon>mdi-close</v-icon>
                      <span>Cancel</span>
                  </v-btn>
                  <v-divider vertical class="mx-1" :disable="disabled"/>
                  <v-btn color="success" small tile text ripple @click="validate()">
                      <v-icon>mdi-disc</v-icon>
                      <span> {{state=='new'?'ADD':'SAVE'}} </span>
                  </v-btn> 
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
          </v-form>
      </v-col>
        

    </v-row>      
  </div>
  
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    data: {
       type: Object,
        default: ()=>{}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      disabled:false,
      show1: false,
      vendor: {profile:{}},
      customer: { type:'Individual'},
      contact_person: { title:"", firstname:"",lastname:"", middle:""},
      contact:{telephone:"", mobile:"",email:""},
      company:{name:""},
      address:{}
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      STATUS() {
        return ['New Application', 'Under-construction', 'Active', "Closed"]
      }
  },
  watch: {
    show (v) {
      if (v) {
        if(this.state!='new'){
          this.vendor = this.data
          this.contact_person =  this.vendor.profile.contact_person 
          this.contact =  this.vendor.profile.contact
          this.address =  this.vendor.profile.address
        }
      } 
    }
  },
  methods: {
    validate(){
      if (this.$refs.form.validate()) {
        if(this.state == 'new') {
           this.Create()
        } else {
          this.Update()
        }
         
      }
    },
    emitToParent () {
        this.$refs.form.reset()
        this.$emit('DialogEvent', "")
    },
    Create(){
          this.vendor.profile.contact_person  = this.contact_person
          this.vendor.profile.contact  = this.contact
          this.vendor.profile.address  = this.address
          this.vendor.added_by= this.$IsNum(this.$session.get('userID'))
          console.log(this.vendor)
          this.$http.post("new_vendor", this.vendor).then(response => {
          console.log("add", response.data)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
         
          this.emitToParent()
        }).catch(e => {
          console.log(e.data)
        })
    },
     Update(){
          this.vendor.profile.contact_person  = this.contact_person
          this.vendor.profile.contact  = this.contact
          this.vendor.profile.address  = this.address
          console.log(this.vendor)
          this.$http.post("update_vendor", this.vendor).then(response => {
          console.log("add", response.data)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        
          this.emitToParent()
        }).catch(e => {
          console.log(e.data)
        })
    }
  }
}
</script>
